import { render, staticRenderFns } from "./Round.vue?vue&type=template&id=41a3b8af&"
import script from "./Round.vue?vue&type=script&lang=js&"
export * from "./Round.vue?vue&type=script&lang=js&"
import style0 from "./Round.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports